// views/auth/register.de.js  (DE)
export const register_i18n = {
  alts: {
    banner: "Registrierungshintergrund",
    brand: "WA Checkin",
    footerLogo: "WA Checkin",
  },

  aria: {
    toggleReferral: "Partnercode ein- oder ausblenden",
    togglePassword: "Passwort ein- oder ausblenden",
  },

  texts: {
    inviteTitle: "Herzlichen Glückwunsch!",
    inviteText: "{name} hat Sie zu WACheckin eingeladen: Sie erhalten {percent} % Rabatt auf Ihre ersten {months} Monate.",
    inviteApplied: "Über Ihren Einladungslink angewendet.",
    panelKicker: "WACheckin · 2026",
    panelCta: "WACheckin entdecken",
    langLabel: "Sprache",
    panelTitle: "Einmal einrichten. Der Rest läuft von allein.",
    panelDesc: "Der Check-in-Link, die Willkommensnachricht, die Schlüssel und die Meldung an die Behörden gehen raus, ohne dass Sie daran denken müssen.",
    title: "Konto erstellen",
    infoTitle: "In wenigen Minuten registriert",
    infoDesc:
      "Tragen Sie Ihre Daten ein und automatisieren Sie Check-in und Gästekommunikation.",
    referralHint: "Nur aktivieren, wenn Sie einen erhalten haben.",
    alreadyHaveAccount: "Sie haben bereits ein Konto?",
  },

  labels: {
    inviteCode: "Einladungscode",
    name: "Name",
    email: "E-Mail",
    password: "Passwort",
    phone: "Telefon",
    referralCode: "Partnercode",
  },

  placeholders: {
    name: "Ihren Namen eingeben",
    email: "Ihre E-Mail eingeben",
    password: "Passwort erstellen",
    referralCode: "Code",
  },

  buttons: {
    submit: "Konto erstellen",
    submitting: "Konto wird erstellt...",
    signIn: "Anmelden",
  },

  validation: {
    phoneRequired: "Geben Sie Ihre Nummer ein, nicht nur die Vorwahl.",
    phoneInvalid: "Diese Nummer ist ungültig. Bitte prüfen Sie sie.",
    invalidReferralCode: "Der Partnercode ist ungültig.",
  },

  toast: {
    signupSuccess: "Konto erfolgreich erstellt!",
    referralCodeError:
      "Der Partnercode ist nicht korrekt. Geben Sie einen gültigen Code ein oder lassen Sie das Feld leer.",
    signupError: "Fehler bei der Registrierung.",
    networkError: "Verbindungsfehler. Bitte versuchen Sie es erneut.",
  },
};
